import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  item_label: {
    textAlign: 'left',
    textTransform: 'capitalize',
    fontSize: '0.9',
  },
}));

export { useStyles };
